var tableFunctions = (function ($) {
    // Auxiliary functions for Datatables
    // Only works for tables that have the css class "data-table-class"
    var initDataTables = function () {
        // Check if function exists
        if ($.isFunction($(window).DataTable)) {
            // Set default pager numbers length
            $.fn.DataTable.ext.pager.numbers_length = 5;
            $.fn.dataTable.moment('DD MMMM YYYY');

            // Configurations
            let _bSort = true;
            let _info = false;
            let _columns = [];
            let _lengthChange = false;
            let _pageSize = 5;
            let _order = [[3, 'asc']];
            let _lengthMenu = [[10, 25, 50, -1], [10, 25, 50, "All"]];
            let _bPaginate = false;

            $(".data-table-class").each(function () {
                // Variables
                let _totalRows = $(this).find("tbody tr").length;

                // Check if table has attribute "page-size" and use that value for pageSize
                if ((typeof $(this).data('page-size') !== undefined) && !isNaN($(this).data("page-size"))) {
                    _pageSize = $(this).data("page-size");

                    if (_pageSize === 0 || _pageSize === "" || _pageSize === -1) {
                        _pageSize = -1;
                        _bPaginate = false;
                    }
                    else {
                        _bPaginate = (_totalRows > _pageSize);
                    }
                }

                // Columns
                $(this).find("thead tr th").each(function (i, elem) {
                    let _item = {};
                    _item["data"] = $.trim($(elem).text());
                    _columns.push(_item);
                });

                // Destroy DataTable case it already exists
                $(this).DataTable().destroy();

                // Initialize DataTable
                $(this).DataTable({
                    "bSort": _bSort,
                    "info": _info,
                    "columns": _columns,
                    "lengthChange": _lengthChange,
                    "pageLength": _pageSize,
                    "order": _order,
                    "language": {
                        "paginate": {
                            "first": "First",
                            "last": "Last",
                            "next": "<span class='pagination-text'>Next</span><i class='fas fa-long-arrow-alt-right ml-10'></i>",
                            "previous": "<i class='fas fa-long-arrow-alt-left mr-10'></i><span class='pagination-text'>Previous</span>"
                        },
                        "emptyTable": ""
                    },
                    "dom": '<"#add">tp',
                    "lengthMenu": _lengthMenu,
                    "bPaginate": _bPaginate,
                    "fnDrawCallback": function (oSettings) {
                        var pagination = $(this).closest('.dataTables_wrapper').find('.dataTables_paginate');
                        if (pagination !== undefined) {
                            pagination.toggle(this.api().page.info().pages > 1);
                        }

                        if ($(".card-assessment-clickable").length > 0) {
                            rebindAssessment();
                        }
                    }
                });
                $.fn.dataTableExt.afnFiltering.length = 0;
                $(this).DataTable().draw();
            });

            $(".data-table-class").on('page.dt', function () {
                var parent = $(this).parent();

                $('html, body').animate({
                    scrollTop: parent.offset().top
                }, 'slow');
            });
        }
    };

    // Function to dynamically add data labels to <td> elements with
    // the <th> elements text of the table
    var addDataLabels = function () {
        $(".table").each(function () {
            let _headers = $(this).find("thead tr th").map(function () { return $(this).text() })
            if (_headers !== undefined && _headers.length > 0) {
                for (var i = 1; i < (_headers.length + 1); i++) {
                    $(this).find("tbody tr td:nth-child(" + i + ")").attr('data-label', _headers[i - 1]);
                }
            }
        });
    };

    var sortEventList = function () {
        $(".trigger_sort_event_name").unbind("click");
        $(".trigger_sort_event_name").on("click", function () {
            $(".order_target_2").click();
            var btnIcon = $(this).find(".btn-icon");

            if ($(".order_target_2").hasClass("sorting_desc")) {
                $(btnIcon).find(".desc").addClass("d-none");
                $(btnIcon).find(".asc").removeClass("d-none");
            }
            else {
                $(btnIcon).find(".asc").addClass("d-none");
                $(btnIcon).find(".desc").removeClass("d-none");
            }
        });
        $(".trigger_sort_event_date").unbind("click");
        $(".trigger_sort_event_date").on("click", function () {
            $(".order_target_1").click();
            var btnIcon = $(this).find(".btn-icon");

            if ($(".order_target_1").hasClass("sorting_desc")) {
                $(btnIcon).find(".desc").addClass("d-none");
                $(btnIcon).find(".asc").removeClass("d-none");
            }
            else {
                $(btnIcon).find(".asc").addClass("d-none");
                $(btnIcon).find(".desc").removeClass("d-none");
            }
        });
    }

    var rebindAssessment = function () {
        if ($(".card-assessment-clickable").length > 0) {
            $(".card-assessment-clickable").off("click");
            $(".card-assessment-clickable").on("click", function () {
                var target = $(this).data("target");

                if (target == undefined) {
                    console.warn("No target detected");
                }
                else {
                    if ($("." + target).length) {
                        $("." + target).click();
                    }
                }
            });
        }
    }

    // Functions avaiable
    return {
        start: function () {
            initDataTables();
            addDataLabels();
            sortEventList();
        }
    };
})(window.jQuery);

window.initTablesFunctions = tableFunctions;
tableFunctions.start();
